import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import autoBind from 'react-autobind';
import { browserHistory } from 'react-router';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import baseTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
import MenuItem from 'material-ui/MenuItem'; // eslint-disable-line no-unused-vars
import RaisedButton from 'material-ui/RaisedButton';
import TextField from 'material-ui/TextField';
import { cyan900 } from 'material-ui/styles/colors';

const propTypes = {
  event: PropTypes.object,
};

class ViewEvent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      event: {
        id: 0,
        type: '',
        eventId: '',
        date: '',
        event: {},
      },
    };
    autoBind(this);
  }
  getChildContext() {
    return { muiTheme: getMuiTheme(baseTheme) };
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.event) {
      const event = nextProps.event;
      this.setState({ event });
    }
  }

  handleCancel() {
    browserHistory.push('/events?page=1');
  }

  render() {
    const styles = {
      floatingLabelStyle: {
        color: cyan900,
      },
      inputStyle: {
        marginRight: '2%',
        width: '250px',
      },
    };
    return (
      <div className="content">
        <div style={{ width: '70%', float: 'left' }}>
          <RaisedButton
            label="Cancel"
            style={{ marginRight: '10px' }}
            primary
            onClick={this.handleCancel}
          />
        </div>
        <br />
        <div style={{ clear: 'both', height: '20px' }}></div>
        <br />
        <TextField
          floatingLabelText="ID"
          floatingLabelStyle={styles.floatingLabelStyle}
          inputStyle={styles.inputStyle}
          value={this.state.event.id}
        />
        <br />
        <TextField
          floatingLabelText="Event Id"
          floatingLabelStyle={styles.floatingLabelStyle}
          value={this.state.event.eventId || ''}
          name="eventId"
          style={styles.inputStyle}
        />
        <TextField
          floatingLabelText="Event Date"
          floatingLabelStyle={styles.floatingLabelStyle}
          value={new Date(this.state.event.date).toLocaleString()}
          name="date"
          style={styles.inputStyle}
        />
        <TextField
          floatingLabelText="Event Type"
          floatingLabelStyle={styles.floatingLabelStyle}
          value={this.state.event.type}
          name="type"
          style={styles.inputStyle}
        />
        <TextField
          floatingLabelText="Event Sub Type"
          floatingLabelStyle={styles.floatingLabelStyle}
          value={this.state.event.subType}
          name="subType"
          style={styles.inputStyle}
        />
        <br />
        <br />
        <lable style={{ color: cyan900 }}>Event Details
          <br />
          <br />
          <pre>
            <code style={{ color: 'black' }}>
              {JSON.stringify(this.state.event.event, null, '  ')}
            </code>
          </pre>
        </lable>
      </div>
    );
  }
}
ViewEvent.childContextTypes = {
  muiTheme: PropTypes.object.isRequired,
};

ViewEvent.propTypes = propTypes;

function mapStateToProps(state) {
  return {
    event: state.events.event,
  };
}

export default connect(mapStateToProps)(ViewEvent);



// WEBPACK FOOTER //
// ./src/components/events/ViewEvent.js